<template>
<!--  <b-row>-->
<!--    <b-col sm="12" class="mx-auto">-->
<!--      <b-card header="Fee Agreement Signed">-->
<!--        <p>Thank you. Your fee agreement has been successfully signed. Our team will now move to the next stage of the-->
<!--          application process.Please note that any fees required for this application will be invoiced and supplied for-->
<!--          payment in a separate email.-->
<!--          <br>-->
<!--          If you would like to download your signed fee agreement before logging out, a download option is provided-->
<!--          below.-->
<!--        </p>-->
<!--        <template slot="footer">-->
<!--          <b-button variant="primary"-->
<!--                    class="mx-3 float-left" @click="download" :disabled="downloading">-->
<!--            <font-awesome-icon icon="download"></font-awesome-icon>-->
<!--            {{ downloading ? 'Download will start shortly, please wait...' : 'Download a copy of your fee agreement' }}-->
<!--          </b-button>-->

<!--          <b-button variant="primary" class="mx-3 float-right" @click="navigateToClientPortal" >-->
<!--               Back to dashboard-->
<!--          </b-button>-->
<!--        </template>-->
<!--      </b-card>-->
<!--    </b-col>-->
<!--  </b-row>-->

  <div class="bg-gray-100 dark:bg-darkPrimary mb-4 rounded-md relative pt-4 lg:pt-0 overflow-y-auto overflow-x-hidden h-screen">

    <div class="pb-6 text-center lg:text-center max-w-2xl mx-auto">
      <h1 class="text-2xl lg:text-4xl dark:text-darkTextLight font-semibold mt-8">
        Thank you for signing the agreement!
      </h1>
      <br />
      <p class="text-sm">Our team will now move to the next stage of the application process. You will receive the invoice related to this fee agreement in a separate email shortly. </p>
      <br />
    </div>
    <div class="bg-white dark:bg-coolGray-800 rounded-lg p-4 overflow-x-auto flex-1 max-w-2xl mx-auto text-center">
      <p class="mt-12 text-sm">Would you like to download your signed fee agreement
        before exiting from this page?</p>
      <div class="flex justify-center mt-8 mb-20">
        <a @click="download" class="flex text-blue-500 cursor-pointer btn btn--default">
          <DownloadIcon size="1.5x" class="mt-0.5 text-black" />
          <span class="hidden md:block text-black">Yes download</span>
        </a>
        <a @click="navigateToClientPortal" class="flex text-blue-500 cursor-pointer btn btn--primary text-white ml-2">
          <HomeIcon size="1.5x" class="mt-0.5 mr-1 text-white" />
          <span class="hidden md:block text-white">Go to Dashboard</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import {mapActions, mapGetters} from "vuex";
import { DownloadIcon, HomeIcon } from 'vue-feather-icons';


export default {

  components: {
    PulseLoader,
    DownloadIcon,
    HomeIcon
  },

  data: function () {
    return {
      downloading: false
    }
  },

  computed: {
    ...mapGetters({
      feeAgreement: 'client/feeAgreement'
    })
  },

  methods: {
    ...mapActions({
      setShowFooter: 'client/setShowFooter'
    }),
    navigateToClientPortal(){
      let a = document.createElement('a');
      a.href=process.env.VUE_APP_CLIENT_PORTAL ;
      a.click();
    },

    download: function () {
        var vm = this;
        let faId = this.feeAgreement.id;
        this.downloading = true;
        this.$http({
          url: `${process.env.VUE_APP_BASE_URL}/${faId}/fee-agreement/download`,
          method: 'GET',
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'fee-agreement_' + Date.now() + '.pdf');
          document.body.appendChild(link);
          link.click();
          vm.downloading = false;
        });
      },
  },
  created() {
    if(this.feeAgreement.status === 'ineligible'){
      this.$router.push('/fa/not-eligible');
    }else{
      this.setShowFooter(false);
    }
  }
}
</script>